import { isDefined } from "@clipboard-health/util-ts";

import { DEFAULT_DISTANCE_IN_MILES_FILTER } from "../constants";
import { type FiltersFormValues } from "./types";

/**
 * Accepts Partial<FiltersFormValues> because callers may provide incomplete
 * shapes or leave fields undefined, and this function must handle that safely.
 */
export function calculateActiveFiltersCount(
  formValues: Partial<FiltersFormValues>,
  datesLength: number
): number {
  const activeFilters = [
    isDefined(formValues.distance) && formValues.distance !== DEFAULT_DISTANCE_IN_MILES_FILTER,
    hasItems(formValues.shiftTimeSlots),
    hasItems(formValues.licenses),
    hasItems(formValues.includedStates),
    datesLength > 0,
    formValues.favoriteWorkplacesOnly === true,
    formValues.includeWindowedOutShifts === true,
  ];

  return activeFilters.filter(Boolean).length;
}

function hasItems(value: unknown): boolean {
  return Array.isArray(value) && value.length > 0;
}
